import useAppStore from "@hooks/useAppStore";
import { useEffect, useState } from "react";

const useSplitter = () => {
  const appStore = useAppStore();
  const [sizes, setSizes] = useState([50, 50]);

  useEffect(() => {
    if ((appStore.showChart || appStore.showSankey) && appStore.showGrid) {
      setSizes([50, 50]);
    } else if (appStore.showChart || appStore.showSankey) {
      setSizes([100, 0]);
    } else if (appStore.showGrid) {
      setSizes([0, 100]);
    }
  }, [appStore.showChart, appStore.showSankey, appStore.showGrid]);

  return { sizes, setSizes };
};

export default useSplitter;